"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2467],{

/***/ 5171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Product_Rating; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./styles/components/Product/Rating/Rating-tw-styles.js
/* harmony default export */ var Rating_tw_styles = ({
    ReviewSectionRating: {
        rating: "Rating text-white relative inline-block",
        star: "mr-6"
    },
    HeroSectionRating: {
        rating: "HeroRating text-darkGrey relative",
        star: "mr-6"
    },
    BaseRating: {
        topStar: "topStar absolute top-0 left-0 overflow-hidden",
        bottomStar: "bottomStar"
    }
});

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/Product/Rating/index.js




const getStars = (ratingArr, starStyle, content)=>{
    return ratingArr.map((n, index)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: starStyle,
            "data-value": index + 1,
            children: String.fromCharCode(content)
        }, index + 1);
    });
};
const Rating = (param)=>{
    let { ratingData , ratingStyle  } = param;
    const { rating , star  } = Rating_tw_styles[ratingStyle];
    const { BaseRating: { topStar , bottomStar  }  } = Rating_tw_styles;
    let maxRating = 5, percentage = ratingData / maxRating * 100, filledStarDecimal = 9733, hollowStarDecimal = 9734;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: rating,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: bottomStar,
                children: getStars([
                    ...Array(maxRating)
                ], star, hollowStarDecimal)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: topStar,
                style: {
                    width: "".concat(percentage, "%")
                },
                children: getStars([
                    ...Array(maxRating)
                ], star, filledStarDecimal)
            })
        ]
    });
};
Rating.propTypes = {
    ratingData: (prop_types_default()).number,
    ratingStyle: (prop_types_default()).string
};
/* harmony default export */ var Product_Rating = (Rating);


/***/ }),

/***/ 2467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Reviews_Reviews; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Carousel/Carousel.js
var Carousel = __webpack_require__(3174);
;// CONCATENATED MODULE: ./styles/components/Product/Reviews/Reviews-tw-styles.js
/* harmony default export */ var Reviews_tw_styles = ({
    default: {
        reviews: "Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next"
    },
    NDReview: {
        reviews: "Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto NDReview",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next"
    },
    xoxoReview: {
        reviews: "Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto xoxo-review",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next"
    },
    kokeshiReview: {
        reviews: "kokeshiReview Reviews ReviewCarousel relative h-auto bg-red overflow-hidden lg:pl-80 lg:h-auto",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next"
    },
    ReviewCard: {
        reviewCard: "ReviewCard w-8/12 pl-25 py-100 lg:mt-0 h-auto lg:h-auto lg:pt-145 lg:pb-160 lg:w-5/12",
        ReviewCardOne: "ReviewCard ReviewCardOne w-full pl-25 py-100 lg:mt-0 h-auto lg:h-auto lg:pt-145 lg:pb-160 ",
        ReviewSectionRating: "ReviewSectionRating",
        description: "header4 text-white",
        reviewerName: "eyebrow-small uppercase text-white mt-48",
        source: "eyebrow-small uppercase text-white mt-8 lg:mt-10",
        prevButton: "flickity-button flickity-prev-next-button previous",
        nextButton: "flickity-button flickity-prev-next-button next"
    }
});

// EXTERNAL MODULE: ./components/Product/RichText/Richtext.js + 1 modules
var Richtext = __webpack_require__(2327);
// EXTERNAL MODULE: ./components/Product/Rating/index.js + 1 modules
var Rating = __webpack_require__(5171);
// EXTERNAL MODULE: ./components/Product/Typography/Typography.js
var Typography = __webpack_require__(8766);
;// CONCATENATED MODULE: ./components/Product/Reviews/ReviewCard.js







const ReviewCard = (param)=>{
    let { cardData , singleCheck  } = param;
    const { ReviewCard: { reviewCard , ReviewCardOne , description , reviewerName , source , ReviewSectionRating  }  } = Reviews_tw_styles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: singleCheck !== true ? reviewCard : ReviewCardOne,
        children: [
            cardData.rating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                ratingData: cardData.rating,
                ratingStyle: ReviewSectionRating
            }),
            cardData.description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Richtext["default"], {
                className: description,
                richTextJson: cardData.description
            }),
            cardData.reviewerName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                className: reviewerName,
                children: cardData.reviewerName
            }),
            cardData.source && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                className: source,
                children: cardData.source
            })
        ]
    });
};
ReviewCard.propTypes = {
    cardData: (prop_types_default()).object,
    singleCheck: (prop_types_default()).any
};
/* harmony default export */ var Reviews_ReviewCard = (ReviewCard);

// EXTERNAL MODULE: ./adapters/cloudinary.adapters.js
var cloudinary_adapters = __webpack_require__(6508);
// EXTERNAL MODULE: ./constants/global.js
var global = __webpack_require__(5379);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(754);
// EXTERNAL MODULE: ./components/Icons/LeftArrow.js
var LeftArrow = __webpack_require__(6073);
// EXTERNAL MODULE: ./components/Icons/RightArrow.js
var RightArrow = __webpack_require__(7286);
;// CONCATENATED MODULE: ./components/Product/Reviews/Reviews.js











const Reviews = (param)=>{
    let { content  } = param;
    const [isMobile, setScreenSize] = (0,react.useState)(true);
    const [PrevButtonHidden, setPrevButtonHidden] = (0,react.useState)(true);
    const [NextButtonHidden, setNextButtonHidden] = (0,react.useState)(false);
    const carouselRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        setScreenSize(window.innerWidth <= global.breakpoints.sP);
        window.addEventListener("resize", ()=>{
            setScreenSize(window.innerWidth <= global.breakpoints.sP);
        });
    }, []);
    const styles = Reviews_tw_styles[content.styles || "default"] || Reviews_tw_styles["default"];
    const { reviews  } = styles;
    const cards = content.reviewsCollection && content.reviewsCollection.items;
    const flickityOptions = {
        cellAlign: "left",
        pageDots: false,
        selectedAttraction: 0.2,
        friction: 0.9,
        dragThreshold: 1,
        prevNextButtons: false
    };
    const addClassForOpacity = ()=>{
        const actualInnerWidth = document.body.clientWidth;
        const reviewCards = document.getElementsByClassName("ReviewCard");
        for(let i = 0; i < reviewCards.length; i++){
            const cardWidth = reviewCards[i].clientWidth;
            const cardLeftVal = reviewCards[i].getBoundingClientRect().left;
            reviewCards[i].classList.remove("display-off");
            if (cardLeftVal + cardWidth > actualInnerWidth) {
                reviewCards[i].classList.add("display-off");
            }
        }
    };
    const setRef = (flickityObj)=>{
        flickityObj.resize();
        flickityObj.on("ready", addClassForOpacity);
        flickityObj.on("settle", addClassForOpacity);
        carouselRef.current = flickityObj;
        carouselRef.current.on("change", handleSlideChange);
    };
    const getCards = (data)=>{
        return data && data.map((cardData)=>{
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews_ReviewCard, {
                        cardData: cardData,
                        singleCheck: content && content.singleReview
                    })
                }, cardData.sys.id);
            }
        });
    };
    const handleSlideChange = (index)=>{
        setPrevButtonHidden(index === 0);
        setNextButtonHidden(index + 1 >= carouselRef.current.cells.length);
    };
    const handleNext = ()=>{
        carouselRef.current.next();
    };
    const handlePrevious = ()=>{
        carouselRef.current.previous();
    };
    const CustomSliderCheck = (prevButton, isPrevButtonHidden, nextButton, isNextButtonHidden)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": constants.btnTooltipPrevious,
                    onClick: handlePrevious,
                    title: constants.btnTooltipPrevious,
                    className: prevButton,
                    disabled: isPrevButtonHidden,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrow/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": constants.btnTooltipNext,
                    onClick: handleNext,
                    title: constants.btnTooltipNext,
                    className: nextButton,
                    disabled: isNextButtonHidden,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow/* default */.Z, {})
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: reviews,
        ...!isMobile && content.backgroundImage && {
            style: {
                backgroundImage: "url(".concat((0,cloudinary_adapters/* getImageUrl */.Jn)(content.backgroundImage.url))
            }
        },
        children: [
            !isMobile && cards.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "slider",
                children: CustomSliderCheck(styles.prevButton, PrevButtonHidden, styles.nextButton, NextButtonHidden)
            }),
            cards.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                options: flickityOptions,
                flickityRefCallback: (ref)=>setRef(ref),
                className: "slider",
                children: getCards(cards)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: getCards(cards)
            }),
            isMobile && content.foregroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: content.foregroundImage.url,
                alt: content.foregroundImage.title
            })
        ]
    });
};
Reviews.propTypes = {
    content: (prop_types_default()).object
};
/* harmony default export */ var Reviews_Reviews = (Reviews);


/***/ })

}]);